import React, { useEffect, useState } from 'react';
import { createStore } from '../store';
import clsx from 'clsx';
import ReactDOM from 'react-dom';
import { useDisableScroll } from '../../ui';
var overlayIndex = createStore(0);
export function Overlay(_a) {
    var children = _a.children, onClose = _a.onClose, className = _a.className;
    var element = useState(document.createElement('div'))[0];
    var _b = overlayIndex.useStore(), index = _b[0], setIndex = _b[1];
    var zIndex = useState(index)[0];
    useDisableScroll(true);
    useEffect(function () {
        setIndex(function (index) { return index + 1; });
        return function () {
            setIndex(function (index) { return index - 1; });
        };
    }, []);
    useEffect(function () {
        document.documentElement.appendChild(element);
        element.className = "overlay-root-" + zIndex;
        return function () {
            document.documentElement.removeChild(element);
        };
    }, [element]);
    return ReactDOM.createPortal(React.createElement("div", { className: clsx('XR-Overlay', "z" + zIndex, className), onClick: onClose }, children), element);
}
